'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const cssVariablesConversion = require('./css-variables-conversion.js');
const unitConversion = require('./unit-conversion.js');

/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */
var parseDomVariant = function (visualElement, target, origin, transitionEnd) {
  var resolved = cssVariablesConversion.resolveCSSVariables(visualElement, target, transitionEnd);
  target = resolved.target;
  transitionEnd = resolved.transitionEnd;
  return unitConversion.unitConversion(visualElement, target, origin, transitionEnd);
};

exports.parseDomVariant = parseDomVariant;
